import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "web-interactive-image-preview" */'./WebInteractivesImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('web-interactive-image-preview')),
  LoadingComponent: () => null
});